/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';

export const Divider = () => {
  const { palette } = useTheme();
  return (
    <hr
      css={{
        border: `1px solid ${palette.grey.x200}`,
        width: '100%',
      }}
    />
  );
};
